module.exports = __webpack_public_path__ + "media/Acting_Dialogue_Confronting.3c77d79b.mp3";